import { View } from "react-native";
import { Checkbox, Text } from "react-native-paper";
import { Control, Controller } from "react-hook-form";
import { EventDetailsQuery, FormData } from "./types";
import { readableDate, readableTime, convertToTimezone, getTimezoneAbbr } from "../../utils/dateUtils";

export default function EventSchedule({ event, control }: { event: EventDetailsQuery["event"]; control: Control<FormData> }) {
  return (
    <View testID="event-schedule">
      <View className="bg-sky-light h-[1px] my-8" />
      <View>
        <Text className="text-large-normal font-700">Event Schedule</Text>
        <Text className="text-regular-normal mt-2">All days/sessions are included in your registration.</Text>
        <View className="mt-6">
          {event.sessions.map(
            ({ id, startsAt, endsAt, title }: { id: string; startsAt: string; endsAt: string; title: string }) => {
              return (
                <View key={id}>
                  <Controller
                    name={`sessions.${id}`}
                    control={control}
                    defaultValue={true}
                    render={() => (
                      <View
                        testID={`schedule-item-${id}`}
                        className="flex flex-row rounded-lg mb-3 border-primary-lighter border-2 p-3"
                      >
                        <View className="self-center mr-2">
                          <Checkbox.Android status="checked" />
                        </View>
                        <View className="flex-1">
                          <View className="flex-row">
                            <Text className="w-3/4 font-700 text-regular-tight mb-1">{title}</Text>
                          </View>
                          <Text>
                            {readableDate(convertToTimezone(startsAt, event.timezone))} |{" "}
                            {readableTime(convertToTimezone(startsAt, event.timezone))} -{" "}
                            {readableTime(convertToTimezone(endsAt, event.timezone))} {getTimezoneAbbr(event.timezone)}
                          </Text>
                        </View>
                      </View>
                    )}
                  />
                </View>
              );
            }
          )}
        </View>
      </View>
    </View>
  );
}
